import { combineReducers } from "redux";
import {
    BUY_COMPANY_AGGREGATED_PRODUCTS_ERROR,
    BUY_COMPANY_AGGREGATED_PRODUCTS_START,
    BUY_COMPANY_AGGREGATED_PRODUCTS_SUCCESS,
    GET_AGGREGATED_PRODUCTS_ERROR,
    GET_AGGREGATED_PRODUCTS_START,
    GET_AGGREGATED_PRODUCTS_SUCCESS,
} from "../actions/products";
import { AggregatedProductInterface } from "../interfaces/products";

interface GetAggregatedProductsPayload
    extends Array<AggregatedProductInterface> {}

export type ProductsAction =
    | { type: typeof GET_AGGREGATED_PRODUCTS_START }
    | {
          type: typeof GET_AGGREGATED_PRODUCTS_SUCCESS;
          payload: GetAggregatedProductsPayload;
      }
    | { type: typeof GET_AGGREGATED_PRODUCTS_ERROR }
    | { type: typeof BUY_COMPANY_AGGREGATED_PRODUCTS_START }
    | { type: typeof BUY_COMPANY_AGGREGATED_PRODUCTS_SUCCESS; payload: any }
    | { type: typeof BUY_COMPANY_AGGREGATED_PRODUCTS_ERROR };

interface AggregatedProductsState {
    result: Array<AggregatedProductInterface>;
    isGettingAggregateProducts: boolean;
    isBuyingAggregatedProducts: boolean;
}

const initialState: AggregatedProductsState = {
    result: [],
    isGettingAggregateProducts: false,
    isBuyingAggregatedProducts: false,
};

const isGettingAggregatedProducts = (
    state = initialState.isGettingAggregateProducts,
    action: ProductsAction,
) => {
    switch (action.type) {
        case GET_AGGREGATED_PRODUCTS_START:
            return true;
        case GET_AGGREGATED_PRODUCTS_SUCCESS:
            return false;
        case GET_AGGREGATED_PRODUCTS_ERROR:
            return false;
        default:
            return state;
    }
};

const isBuyingAggregatedProducts = (
    state = initialState.isBuyingAggregatedProducts,
    action: ProductsAction,
) => {
    switch (action.type) {
        case BUY_COMPANY_AGGREGATED_PRODUCTS_START:
            return true;
        case BUY_COMPANY_AGGREGATED_PRODUCTS_SUCCESS:
            return false;
        case BUY_COMPANY_AGGREGATED_PRODUCTS_ERROR:
            return false;
        default:
            return state;
    }
};

const data = (state = initialState.result, action: ProductsAction) => {
    switch (action.type) {
        case GET_AGGREGATED_PRODUCTS_START:
            return [];
        case GET_AGGREGATED_PRODUCTS_SUCCESS:
            return action.payload;
        case GET_AGGREGATED_PRODUCTS_ERROR:
            return [];
        default:
            return state;
    }
};

const aggregatedProducts = combineReducers({
    isGettingAggregatedProducts,
    isBuyingAggregatedProducts,
    data,
});

export default aggregatedProducts;
